import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';

export const RedemptionStepsList = styled.ol`
  counter-reset: redemption-steps-counter;
  list-style: none;
  padding-left: 24px;
`;

export const RedemptionStepsItem = styled.li`
  counter-increment: redemption-steps-counter;
  position: relative;
  padding-bottom: 8px;

  &::before {
    content: counter(redemption-steps-counter);
    position: absolute;
    left: -24px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    background-color: ${colors.lightGray2};
    color: ${colors.white};
    border-radius: 50%;
    font-size: 10px;
    text-align: center;
  }
`;
